import React from 'react'

const AttendancesTab = () => {
  return (
    <div>AttendancesTab</div>
  )
}

export default AttendancesTab